/*
 * Copyright (c) 2020 General Electric Company. All rights reserved.
 *
 * The copyright to the computer software herein is the property of
 * General Electric Company. The software may be used and/or copied only
 * with the written permission of General Electric Company or in accordance
 * with the terms and conditions stipulated in the agreement/contract
 * under which the software has been supplied.
 */

import { NavigatorList } from './navigator-list';

export class SavedList extends NavigatorList {
  depth: number;
  displayName: string;
  parent: any;
  isSharedByMe: boolean;
  isSharedWithMe: boolean;
  isDescriptionMandatory: boolean;
  folderMembers: any;
  isSavedList = true;
  isPinned: boolean;
  worklistId: string;
  layoutId: string;
  isWorklistDisabled = false;

  private folderIcons = ['ico-folder-32'];
  private sharedFolderIcons = ['ico-export-32'];

  constructor(id, displayName, parent, config?) {
    super('saved-item-list', {
      isFilterable: true,
      isSortable: true,
      isOpen: true
    });

    this.id = id === undefined ? '' : id.toString();
    this.worklistId = id.toString();
    this.displayName = displayName;
    this.parent = parent;
    this.depth = parent ? parent.depth + 1 : 0;
    this.layoutId = config && config.layoutId;
    this.isPinned = !!(config && config.pinned);
    this.isSharedByMe = !!(config && config.sharedByMe);
    this.isSharedWithMe = !!(config && config.sharedWithMe);
    this.isDescriptionMandatory = !!(config && config.descriptionMandatory);

    this.icons = this.isSharedByMe || this.isSharedWithMe ? this.sharedFolderIcons : this.folderIcons;
  }
}
